/** @format  */

import { useCallback, useMemo, useState } from "react";
import changelogRaw from "../../../../../CHANGELOG.md?raw";
import { compareVersions, parseChangelog } from "./parseChangelog";

const LAST_SEEN_VERSION_STORAGE_KEY = "whatsChanged.lastSeenVersion.v1";

export const VISIBLE_RELEASE_COUNT = 3;

const readLastSeenVersion = (): string | null => {
	try {
		const storedVersion = localStorage.getItem(LAST_SEEN_VERSION_STORAGE_KEY);

		if (storedVersion !== null && !/^\d+\.\d+\.\d+$/.test(storedVersion)) {
			return null;
		}
		return storedVersion;
	} catch (error) {
		console.warn("Failed to read the last seen changelog version", error);
		return null;
	}
};

export const useWhatsChanged = () => {
	const releases = useMemo(() => parseChangelog(changelogRaw).slice(0, VISIBLE_RELEASE_COUNT), []);
	const [lastSeenVersion, setLastSeenVersion] = useState<string | null>(readLastSeenVersion);

	const currentVersion = releases.length > 0 ? releases[0].version : "";

	const unseenCount = useMemo(() => {
		if (lastSeenVersion === null) {
			return releases.length;
		}
		return releases.filter((release) => compareVersions(release.version, lastSeenVersion) > 0).length;
	}, [releases, lastSeenVersion]);

	const markSeen = useCallback(() => {
		setLastSeenVersion(currentVersion);
		try {
			localStorage.setItem(LAST_SEEN_VERSION_STORAGE_KEY, currentVersion);
		} catch (error) {
			console.warn("Failed to store the last seen changelog version", error);
		}
	}, [currentVersion]);
	return { releases, currentVersion, unseenCount, markSeen };
};
